import { jsx as n, jsxs as B } from "react/jsx-runtime";
import { useRef as b, useState as y, useCallback as E } from "react";
import i from "./index.es5768.js";
import A from "classnames";
import { Link as F } from "./index.es62.js";
import { SimpleTooltip as M } from "./index.es120.js";
import { Icon as H } from "./index.es147.js";
const S = "copy-to-clipboard", j = async (s) => {
  try {
    await navigator.clipboard.writeText(s);
  } catch (c) {
    console.error("Failed to copy text: ", c);
  }
}, J = ({
  children: s,
  tooltipText: c,
  icon: O = {
    hasIcon: !1,
    position: "start",
    showOnHover: !1
  },
  testId: p = S,
  copyTarget: x = "text",
  ...h
}) => {
  const v = b(null), a = b(null), { hasIcon: D, position: f, showOnHover: u } = O, t = x === "icon", C = D || t, _ = A(i.root, {
    [i.showIcon]: C && !u,
    [i.showIconOnHover]: u && C
  }), { beforeCopy: k, afterCopy: w } = c || {}, l = k || "Copy to clipboard", L = w || "Copied to clipboard", [P, e] = y(!1), [R, d] = y(l), m = async () => {
    await j(s), d(L);
  }, r = E(
    (o) => {
      e(o), o || d(l);
    },
    [l]
  ), T = () => /* @__PURE__ */ n(
    H,
    {
      type: "ClipboardText",
      size: 16,
      onClick: m,
      onFocus: () => {
        setTimeout(() => {
          var o;
          (o = a.current) == null || o.focus();
        }), e(!0);
      },
      onBlur: () => e(!1),
      onMouseEnter: () => r(!0),
      onMouseLeave: () => r(!1),
      tabIndex: t ? 0 : -1,
      ref: a
    }
  );
  return /* @__PURE__ */ n(
    M,
    {
      title: R,
      open: P,
      testId: p + "-tooltip",
      children: /* @__PURE__ */ B("div", { className: _, tabIndex: -1, children: [
        f === "start" && /* @__PURE__ */ n(T, {}),
        /* @__PURE__ */ n(
          F,
          {
            ref: v,
            onClick: t ? void 0 : m,
            onFocus: (o) => {
              var I;
              t ? ((I = a.current) == null || I.focus(), o.preventDefault()) : e(!0);
            },
            onBlur: () => e(!1),
            onMouseEnter: () => r(!0),
            onMouseLeave: () => r(!1),
            testId: p,
            tabIndex: t ? -1 : 0,
            ...h,
            children: s
          }
        ),
        f === "end" && /* @__PURE__ */ n(T, {})
      ] })
    }
  );
};
export {
  J as CopyToClipboard,
  S as DEFAULT_COPY_TO_CLIPBOARD_TESTID
};
//# sourceMappingURL=index.es5736.js.map
